import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { orgServiceModel, ResourceChangeRequestDetail, ResourceChangeRequestDetailItem, ServiceFeatureModel } from '../../models';
import { SubscriptionService } from '../../services/subscription.service';
import { ApiService } from '../../../../services/api.service';
import { AppConfig } from '../../models/app-config';

@Component({
  selector: 'app-subscription-resource-editor',
  templateUrl: './subscription-resource-editor.component.html',
  styleUrls: ['./subscription-resource-editor.component.scss']
})
export class SubscriptionResourceEditorComponent implements OnInit {
    @Input() service: orgServiceModel;
    features: ServiceFeatureModel[] = [];
    @Input() edit = false;
    billingPeriod = '';
    total = 0;
    serviceTemplate: ServiceFeatureModel[] = [];
    initRequired = true;
    blockSize = 0;

    @Output() newTotal: EventEmitter<number> = new EventEmitter<number>();
    @Output() resourcesChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private sub: SubscriptionService,
        private data: ApiService) {
        this.blockSize = AppConfig.settings.companyBlockSize;
    }

    async ngOnInit() {
        this.serviceTemplate = await this.sub.getAvailableServiceFeatures(this.data);
        if(this.initRequired){
            this.initRequired = false;
            this.initFeatures();
        }
    }

    @Input() set serviceItem(s: orgServiceModel) {
        this.service = s;
        this.initFeatures();
    }

    initFeatures(){
        this.features = [];
        if(!this.serviceTemplate){
            this.initRequired = true;
            return;
        }

        this.serviceTemplate.forEach(svcOpt => {
            
            const f = this.service.features.find(x=>x.featureKey === svcOpt.featureKey);
            if(f){
                const feature = new ServiceFeatureModel();
                feature.cost = f.cost;
                feature.featureDescripion = f.featureDescripion;
                feature.featureKey = f.featureKey;
                feature.featureName = f.featureName;
                feature.quantity = f.quantity;
                feature.usage = f.usage;
                feature.blockQuantity = Math.ceil((f.quantity - 1) / this.blockSize);
                this.total += f.cost;
                this.features.push(feature);
            }else{
                this.features.push(svcOpt);
            }
            
        });
        
        this.calcTotal();
    }

    @Input() set billingPeriodData(p: string) {
        console.log('New period data received: ' + p);
        this.billingPeriod = p;
        this.reloadPricing();
    }

    getFeatureDetails() {
        const details = new ResourceChangeRequestDetail();
        details.items = [];
        this.features.forEach(r => {
            const itm = new ResourceChangeRequestDetailItem();
            itm.featureKey = r.featureKey;
            itm.featureName = r.featureName;
            itm.quantity = r.quantity;
            itm.cost = r.cost;
            details.items.push(itm);
        });

        return details;
    }

    currentQuantity = 0;

    async quantityFocus(i: number){
        //This method ensures that the value before databind-updates is stored
        const f = this.features[i];
        this.currentQuantity = f.quantity;
    }

    //Used by the text box containing the quantity if value is updated by keyboard
    // async quantityChanged(i: number){
    //     //As we are using ngModel binding, the quantity of the feature object is changed
    //     //  directly.  So the new quantity is the current value, and the prevValue is 
    //     //  stored in currentQuantity property
    //     const f = this.features[i];
    //     const newQuantity = f.quantity;



    //     //If the updateQuantity method returns true, the change was accepted
    //     if(!await this.updateQuantity(i, this.currentQuantity, newQuantity)){
    //         //But if it returns false, we have to restore to the previously bound value
    //         f.quantity = this.currentQuantity;
    //         //We should update the total for good measure
    //         await this.reloadPricing();
    //     }

    //     //Clear the currentQuantity field as we have finished editing
    //     this.currentQuantity = 0;        
    // }

    //Used by the 'increase' UI button
    async increase(i: number) {
        const f = this.features[i];
        f.blockQuantity += 1;
        const newQ = f.blockQuantity * this.blockSize + 1;
        console.log("Increase quantity via button");
        await this.updateQuantity(i, f.quantity, newQ, f.blockQuantity);    
    }

    //Used by the 'decrease' UI button
    async reduce(i: number) {
        const f = this.features[i];
        f.blockQuantity -= 1;
        const newQ = f.blockQuantity * this.blockSize + 1;
        if(newQ < 1){
            console.log("Feature quantity is less than 1, which is not permitted");
            f.blockQuantity = 0;
            return;
        }
        console.log("Decrease quantity via button");

        await this.updateQuantity(i, f.quantity, newQ, f.blockQuantity);
    }

    //Used by all functions that respond to UI quantity changes
    async updateQuantity(index: number, prevQuantity: number, newQuantity: number, blockCount: number): Promise<boolean>{
        console.log("Update quantity from " + prevQuantity + " to " + newQuantity);
        const f = this.features[index];

        if(prevQuantity === newQuantity){
            //No change, so just return
            return false;
        }

        //Validate proposed new quantity value
        if(f.featureKey === 'Core'){
            //If feature is 'core', it must not be less than 1, less than current usage,
            // and no other feature can be higher. 
            //2022-06-28 We also need to check that resource usage hasn't gotten above actual usage in error, 
            //  in which case the new quantity will go to current usage
            console.log("Modifying core feature");
            if(newQuantity < 1){
                console.log("Core quantity is less than 1, which is not permitted");
                return false;
            }
            if(newQuantity < f.usage){
                console.log("Core quantity is less than usage, which is not permitted.  Set newQuantity to current usage");
                newQuantity = f.usage;
                //return false;
            }

            let featureCheck = true;
            this.features.forEach(r => {
                if(r.featureKey !== 'Core'){
                    //console.log("Non-core feature quantity = " + r.quantity);
                    console.log("Non-core feature will now be allocated the same usage as core");
                    r.quantity = newQuantity;
                    r.blockQuantity = blockCount;
                    // if(newQuantity < r.quantity){
                    //     console.log("Core quantity is less than usage on " + r.featureKey + " feature, which is not permitted.  Set newQuantity to current usage");
                    //     newQuantity = r.quantity;
                    //     //featureCheck = false;
                    //     return;
                    // }
                }
            });
            if(!featureCheck){
                return false;
            }
        }else{
            //2024-11-29: THIS IS NOT GOING TO BE USED GOING FORWARD
            //  All features will be set to the Core level.
            //Feature is not core is must not be less than 0, less than current usage (if any) 
            //    and greater than Core
            if(newQuantity < 0){
                console.log("Feature quantity is less than 0, which is not permitted");
                return false;
            }
            if(newQuantity < f.usage){
                console.log("Feature quantity is less than usage, which is not permitted.  Set newQuantity to current usage");
                newQuantity = f.usage;
                //return false;
            }
            const coreFeature = this.features.find(x=>x.featureKey === 'Core');
            if(newQuantity > coreFeature.quantity){
                console.log("Feature quantity is greater than core, which is not permitted");
                return false;
            }
        }

        console.log("New quantity has been accepted.  Calculating updated prices");
        f.quantity = newQuantity;
        await this.reloadPricing();
        return true;
    }

    // async calcTotals(f: ServiceFeatureModel){
    //     const getCostRes = await this.sub.calculatePeriodServiceCost(this.service.billingOrganisationId,
    //         this.service.serviceKey,
    //         f.featureKey,
    //         f.quantity,
    //         this.billingPeriod,
    //         this.service.id);
    //     f.cost = getCostRes.data;
    //     this.calcTotal();
    // }

    async reloadPricing() {
        const promises = this.features.map(f => this.sub.calculatePeriodServiceCost(this.service.billingOrganisationId,
            this.service.serviceKey,
            f.featureKey,
            f.quantity,
            this.billingPeriod,
            this.service.id));

        const results = await Promise.all(promises);

        this.features.forEach((f, idx) => {
            f.cost = results[idx].data;
        });

        this.calcTotal();
    }

    calcTotal() {
        this.total = this.features.reduce((s, model) => {
            return s + model.cost;
        }, 0);

        this.newTotal.emit(this.total);
        this.determineIfChanges();
    }

    determineIfChanges(){
        let changes = false;
        this.features.forEach(f => {
            const ftr = this.service.features.find(x=>x.featureKey === f.featureKey);
            if(ftr){
                if(ftr.blockQuantity !== f.blockQuantity){
                    changes = true;
                }
            }else{
                //If we don't have the feature, we may be adding it, so set true providing quantity > 0
                if(f.blockQuantity > 0){
                    changes = true;
                }
            }
        });

        this.resourcesChanged.emit(changes);
    }
}
